import { useQuery } from '@tanstack/react-query';

import { getContestTemplate } from '../domains/managev2/domains/common/utils/getContestTemplate';
import { ContestQueryKeys } from '../constants/query';

type UseContestTemplateArgs = {
  params: {
    contestTemplateId: string;
  };
  enabled?: boolean;
};
export const useContestTemplate = ({
  params: { contestTemplateId },
  enabled,
}: UseContestTemplateArgs) =>
  // eslint-disable-next-line local-rules/require-query-stale-time
  useQuery({
    queryKey: ContestQueryKeys.CONTEST_TEMPLATE_BY_CONTEST_TEMPLATE_ID({
      contestTemplateId,
    }),
    queryFn: () => getContestTemplate(contestTemplateId),
    enabled: !!contestTemplateId && enabled,
  });
